angular.module("app").controller("GamesAddPageController", [
    '$scope',
    'casinoGameService',
    'errorHandler',
    'preloadedCategories',
    'preloadedSubCategories',
    'preloadedProviders',
    'casinoGameTypes',
    '$filter',
    'ratios',
    'pageStatuses',
    'logger',
    function ($scope, casinoGameService, errorHandler, preloadedCategories, preloadedSubCategories, preloadedProviders, casinoGameTypes, $filter, ratios, pageStatuses, logger) {
        var init,
            types = [],
            translator = $filter('translate');

        casinoGameTypes.forEach(function (value) {
            types.push({
                id: value,
                title: translator('casinoGame.addEdit.types.' + value)
            })
        });

        $scope.ratios = ratios;

        $scope.pageStatuses = pageStatuses;

        $scope.tooltip = {
            name: "",
            height: "",
            width: "",
            downloadLinkWindows: "",
            downloadLinkLinux: "",
            downloadLinkMac: ""
        };

        $scope.save = function () {
            var requestData = {
                casinoGame: fetchRequestData ()
            };

            casinoGameService.create(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("saved");
                        init();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function fetchRequestData () {
            var fetchedData = angular.extend({}, $scope.gameData);


            fetchedData.categories = [];
            fetchedData.subCategories = [];
            fetchedData.types = [];

            $scope.multiSelect.selectedCategories.forEach(function (value) {
                fetchedData.categories.push(value.id)
            });
            $scope.multiSelect.selectedSubCategories.forEach(function (value) {
                fetchedData.subCategories.push(value.id)
            });
            $scope.multiSelect.selectedCasinoGameTypes.forEach(function (value) {
                fetchedData.types.push(value.id)
            });

            return fetchedData
        }

        (init = function () {

            $scope.multiSelect = {
                selectedCategories: [],
                selectedSubCategories: [],
                categories: angular.copy(preloadedCategories),
                subCategories: angular.copy(preloadedSubCategories),
                casinoGameTypes: types,
                selectedCasinoGameTypes: []
            };

            $scope.providers = angular.copy(preloadedProviders);

            $scope.gameData = {
                description: "",
                name: "",
                height: undefined,
                width: undefined,
                provider: $scope.providers[0].name,
                showAsProvider: $scope.providers[0].name,
                ratio: ratios[0],
                status: pageStatuses[0],
                background: undefined,
                betconstruct_jackpot: false,
                global_jackpot: false,
                icon_1: undefined,
                icon_2: undefined,
                icon_3: undefined
            };

            $scope.add_games_form && $scope.add_games_form.$setPristine()
        })()

    }
]);